'use strict';

module.exports = 2048;
